/**
 * Lenis smooth scroll
 * Initializes smooth scrolling on all pages, synced with GSAP ScrollTrigger
 *
 * @package StandOut
 * @since 2.0.0
 */
import "lenis/dist/lenis.css";
import Lenis from "lenis";
const lenis = new Lenis();
// Sync with GSAP ScrollTrigger when available
const syncWithGsap = () => {
    lenis.on("scroll", ScrollTrigger.update);
    gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);
};
if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
    syncWithGsap();
}
else {
    window.addEventListener("gsap-loaded", syncWithGsap, { once: true });
}
// Expose globally for other modules to access (e.g. to stop/start during pinned sections)
globalThis.lenis = lenis;
